import React from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "../components/Header";
import AboutSection from "../components/AboutSection";
import WorkSection from "../components/WorkSection";
import ContactSection from "../components/ContactSection";

export const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.substring(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div id="home" className="home flex flex-col min-h-screen">
      <Header />
      {/* Hero / Tagline */}
      <section className="flex-1 flex flex-col items-center justify-center text-center px-4 py-16 bg-pastel-pink">
        <h1 className="text-4xl md:text-5xl font-display font-bold text-gray-800 max-w-3xl">
          I build systems that scale and tools that help developers scale faster.
        </h1>
        <p className="mt-6 text-lg text-gray-600 max-w-xl">
          Software engineer with 5+ years crafting distributed systems, developer tooling, and SDLC platforms.
        </p>
      </section>
      <AboutSection />
      <WorkSection />
      <ContactSection />
    </div>
  );
};
